import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  reportId: string;
};

export const getReportStatus = createQueryFn(
  QueryNameSpace.getReportStatus,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const { statuses } = await DigiobcanApi.getReportStatus(params.reportId);

    return statuses;
  },
);
